const STYLEGUIDE_VERSION = 'v3';
const UI_LIBRARY_PREFIX = 'z';

const EVENT_NAMES = {
  DELIVERY_SERVICE_SELECTED: 'deliveryservices.option.selected',
  DELIVERY_SERVICE_UNAVAILABLE: 'deliveryservices.option.unavailable',
  DELIVERY_SERVICE_PUDO_CANCELED: 'deliveryservices.pudo.canceled',
  DELIVERY_SERVICE_INFO: 'deliveryservices.option.logistics.selected',
  CART_SERVICE_ADD_TO_CART_SUCCESS: 'ADD-TO-CART-SUCCESS-v1',
  SAVINGS_PLAN_OFFER_FAILURE: 'SAVINGS-PLAN-OFFER-FAILURE-v1',
  GET_CART_ID: 'GET-CART-ID-v1',
};

const ERROR_MESSAGES = {
  EMPTY_BODY: 'Empty body',
  UNKNOWN_CITY: 'UNKNOWN_CITY',
};

const PLATFORM_TYPE = {
  IOS: 'IOS',
  ANDROID: 'ANDROID',
  WEB: 'WEB',
};

const CONSTANTS = {
  ...EVENT_NAMES,
  STYLEGUIDE_VERSION,
  UI_LIBRARY_PREFIX,
  PLATFORM_TYPE,
  ERROR_MESSAGES,
};

export default CONSTANTS;
